var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWaveEnd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#3b82f6;stroke-width:0px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "visual"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,8.91l25.7.62c25.6.62,77,1.87,128.5,1.38,51.5-.48,103.1-2.69,154.6-2.59,51.5.1,102.9,2.53,154.2,3.75,51.3,1.22,102.7,1.26,154-.05s102.7-3.97,154.2-4.32c51.5-.34,103.1,1.63,154.6,2.15s102.9-.41,128.5-.88l25.7-.47V0H0v8.91Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveEnd);
export default __webpack_public_path__ + "static/media/wave-end.7217b5a61beaf0526a952c82af0e2f29.svg";
export { ForwardRef as ReactComponent };